import './features.css'
import featuresImg1 from '../../assets/images/features-img-1.svg'
import featuresImg2 from '../../assets/images/features-img-2.svg'
import featuresImg3 from '../../assets/images/features-img-3.svg'

const Features = () => {
    return (
        <div className="features-area pt-100 pb-70">
            <div className="container">
                <div className="section-title">
                    <span className="top-title">Our Features</span>
                    <h2>How Can We Help You</h2>
                </div>
                <div className="row justify-content-center">
                    <div className="col-lg-4 col-sm-6 col-md-6" >
                        <div className="single-features-content">
                            <img src={featuresImg1} alt="images" />
                            <h3>Management Tenants</h3>
                            <p>Lorem ipsum dolor sit amet cons
                                elit sed do eiusmod tempor incididunt ut labore et do magna aliqua do magna enim ad minim.</p>
                            <a href="#" className="default-btn btn-style-two">Read More</a>
                        </div>
                    </div>
                    <div className="col-lg-4 col-sm-6 col-md-6" >
                        <div className="single-features-content">
                            <img src={featuresImg2} alt="images" />
                            <h3>Leakage Detection</h3>
                            <p>Lorem ipsum dolor sit amet cons
                                elit sed do eiusmod tempor incididunt ut labore et do magna aliqua do magna enim ad minim.</p>
                            <a href="#" className="default-btn btn-style-two">Read More</a>
                        </div>
                    </div>
                    <div className="col-lg-4 col-sm-6 col-md-6" >
                        <div className="single-features-content">
                            <img src={featuresImg3} alt="images" />
                            <h3>Residential Services</h3>
                            <p>Lorem ipsum dolor sit amet cons
                                elit sed do eiusmod tempor incididunt ut labore et do magna aliqua do magna enim ad minim.</p>
                            <a href="#" className="default-btn btn-style-two">Read More</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Features